"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskManagedAttributesRealTimeEvents = void 0;
var TaskManagedAttributesRealTimeEvents;
(function (TaskManagedAttributesRealTimeEvents) {
    TaskManagedAttributesRealTimeEvents["TASK_MANAGED_ATTRIBUTE_UPDATE"] = "task managed attribute update";
    TaskManagedAttributesRealTimeEvents["TASK_MANAGED_ATTRIBUTE_DELETE"] = "task managed attribute delete";
})(TaskManagedAttributesRealTimeEvents = exports.TaskManagedAttributesRealTimeEvents || (exports.TaskManagedAttributesRealTimeEvents = {}));
//# sourceMappingURL=internal-types.js.map